module.exports = __webpack_public_path__ + "img/VN-005HT.bc622d17.png";